import React from 'react'
import {
  list,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { useSelector } from 'react-redux'
import { selectUsageForProduct } from 'ducks/billing/selectors/usage'
import { KB } from 'ducks/billing/productTypes'
import Feature from './Feature'
import { styles } from '../styles'

export default function KbFeatures({
  className,
  maxKbs,
  maxArticles,
  branding,
  customScripts,
  seo,
  private: privateKb,
}) {
  const usage = useSelector(state => selectUsageForProduct(state, KB))
  return (
    <>
      <div
        className="grui mt-10"
        css={[text.styles.textSm, text.styles.fontMedium]}
      >
        Knowledge Base
      </div>
      <ul css={[list.styles.preflight, styles.features]} className={className}>
        {maxKbs !== 'unlimited' &&
          usage.kbs > maxKbs && (
            <Feature>
              Remove Knowledge Bases (Limit of {maxKbs}, {usage.kbs} in{` `}use)
            </Feature>
          )}
        {maxArticles !== 'unlimited' &&
          usage.articles > maxArticles && (
            <Feature>
              Remove articles (Limit of {maxArticles}, {usage.articles} in{` `}use)
            </Feature>
          )}
        {!customScripts &&
          usage.customScripts && <Feature>Disable Custom Scripts</Feature>}
        {!seo &&
          usage.seo && <Feature>Disable SEO and Open Graph settings</Feature>}
        {!privateKb &&
          usage.private && <Feature>Disable Access Control</Feature>}
        {!branding &&
          usage.branding && <Feature>Enable Groove branding</Feature>}
      </ul>
    </>
  )
}
